import * as types from './PanelControlTypes';

export default function PanelControlReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PANEL_CONTROL_CONFIG:
            return {
                ...state,
                getPanelControlConfig: {
                    ...state.getPanelControlConfig,
                    config: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PANEL_CONTROL_CONFIG_LOADING:
            return {
                ...state,
                getPanelControlConfig: {
                    ...state.getPanelControlConfig,
                    loading: true
                },
            };
        case types.GET_PANEL_CONTROL_CONFIG_ERROR:
            return {
                ...state,
                getPanelControlConfig: {
                    ...state.getPanelControlConfig,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
    
        default:
            return state;
    }
}